import { useContext } from 'react';
import { ServicesContext } from './ServicesContext';
export const useServicesContext = () => {
    const servicesContext = useContext(ServicesContext);
    if (servicesContext === undefined) {
        throw new Error('useServicesContext must be used within a ServicesContext Provider');
    }
    return servicesContext;
};
